<template>
  <div class="map-input">
    <v-row v-if="coordinates">
      <v-col md="6">
        <v-text-field v-model="coordinates[0]" label="Latitude" @focus="toggleMap()" class="py-0" :rules="rules" />
      </v-col>
      <v-col  md="6">
        <v-text-field v-model="coordinates[1]" label="Longitude" @focus="toggleMap()" class="py-0" :rules="rules" />
      </v-col>
    </v-row>

    <div
      class="map-container"
      tabindex="0"
      v-show="open"
      @blur="toggleMap()"
    >
      <Map
        @ready="onMapReady"
        @click="onMapClick"
        :center.sync="center"
      >
        <MapControl position="topright">
          <div class="leaflet-bar" v-if="coordinates[0] && coordinates[1]">
            {{ coordinates[0] }}, {{ coordinates[1] }}
          </div>
        </MapControl>
        <MapControl position="topleft">
          <div class="leaflet-bar">
            <a class="leaflet-control-button" title="Directions" role="button" aria-label="Get directions" @click="toggleMap()">
              <i class="fa fa-check" />
            </a>
          </div>
        </MapControl>

        <MapMarker
          v-if="coordinates[0] !== 0 && coordinates[1] !== 0"
          icon="fa-location-arrow"
          bouncing
          :bouncing-duration="1"
          :coordinates="coordinates"
        />
      </Map>
    </div>
  </div>
</template>

<script>
import 'leaflet-extra-markers'
import 'leaflet.smooth_marker_bouncing'

import Map from '@/components/map/Map'
// import MapPolygon from '@/components/map/MapPolygon'
import MapControl from '@/components/map/MapControl'
import MapMarker from '@/components/map/MapMarker'

export default {
  name: 'MapInput',
  components: {
    Map,
    // MapPolygon,
    MapControl,
    MapMarker
  },
  props: {
    coordinates: {
      type: Array,
      default: () => [0, 0]
    },
    rules: {
      type: Array,
      defualt: () => []
    }
  },
  data () {
    return {
      map: null,
      open: false,
      center: [44.941671, -93.192408]
    }
  },
  methods: {
    onMapReady (e) {
      this.map = e
    },
    onMapClick (e) {
      const coordinates = [e.latlng.lat, e.latlng.lng]
      this.$emit('update:coordinates', coordinates)
    },
    async toggleMap () {
      this.open = !this.open
      await this.$nextTick()
      this.map.invalidateSize()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/leaflet/dist/leaflet.css';
@import '../../node_modules/leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';

.map-container {
  width: 450px;
  height: 450px;
  position: absolute;
  z-index: 999;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);

  .map {
    height: 100%;
    width: 100%;
  }
}
</style>
